// Fallback used whenever an organization hasn't set its own privacy policy (termsUrl).
// The backend already applies this same fallback for the main sign-up flows, this is
// just a defensive default in case termsUrl still reaches the client empty.
export const DEFAULT_TERMS_URL = 'https://www.magma.app/privacy';
